import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
    Output,
    EventEmitter,
    Renderer2
} from '@angular/core';
import {
    FormControl
} from '@angular/forms';
import {
    MatFormField
} from '@angular/material/form-field';

@Component({
    selector: 'app-creep-name-field',
    templateUrl: './creep-name-field.component.pug',
    styleUrls: ['./creep-name-field.component.less']
})
export class CreepNameFieldComponent implements OnInit {
    @ViewChild('input', {static: false}) input: ElementRef;
    @ViewChild('nameRef', {static: false}) nameRef: ElementRef;
    @ViewChild('matFormFieldRef', {static: false}) matFormFieldRef: MatFormField;

    @Input() control: FormControl;
    @Input() minWidth: string;
    @Input() placeholder: string;
    @Input() creeps: IPowerCreep[];

    @Output() blur: EventEmitter<any> = new EventEmitter();

    constructor(
        private _renderer: Renderer2
    ) {
    }

    ngOnInit() {
        this.input.nativeElement.focus();
        this.control.valueChanges.subscribe((value) => this.onChangeName(value));
        this.onChangeName(this.control.value);
    }

    onChangeName(value) {
        const match = this.creeps.find(({ name }) => name === value);

        if (match) {
            this.control.setErrors({ 'match': true });
        }

        this.nameRef.nativeElement.innerText = value;
        let width = this.nameRef.nativeElement.offsetWidth;

        const minWidth = parseInt(this.minWidth, 10);
        if (width < minWidth) {
            width = minWidth;
        }

        this._renderer.setStyle(this.matFormFieldRef._elementRef.nativeElement, 'width', `${ width }px`);
    }
}
